import type { IAlertDismissConfig } from '../types';

import * as exButton from '../../button';

import close from './close';

// ----------------------------------------------------------------------------

function createDismissButton(element: HTMLElement, config: IAlertDismissConfig = {}): Record<string, any> {
    const buttonDismiss = exButton.create({
        merge: config,
        class: {
            new: 'btn-close',
        },
    });

    if (config.bootstrap === true) {
        buttonDismiss.element.dataset.bsDismiss = 'alert';
    }

    buttonDismiss.element.addEventListener('click', function (): any {
        close(element);
    });

    return buttonDismiss;
}

// ----------------------------------------------------------------------------

export default createDismissButton;
